export const validator = {
  percentage: (value, columnId) => {
    const isEmpty = isAndAllowEmpty(value, columnId);
    if (isEmpty) {
      return isEmpty;
    }
    const reg = /\B(?=(\d{3})+(?!\d))/g;
    if (/^[0-9.]+%$|0$/.test(value)) {
      const parts = value.replace('%', '').split('.');
      if (parts[1]) {
        parts[1] = '.' + parts[1];
      } else {
        parts[1] = '';
      }
      return {
        msg: '',
        value: `${parts[0].replace(reg, ',')}${parts[1]}%`,
        isValid: true
      };
    } else {
      return {
        msg: '请填写正确的百分数',
        value: value,
        isValid: false
      };
    }
  },
  date: (value, columnId) => {
    const isEmpty = isAndAllowEmpty(value, columnId);
    if (isEmpty) {
      return isEmpty;
    }
    if (/^[1-9]\d{3}\/(0[1-9]|1[0-2])\/(0[1-9]|[1-2][0-9]|3[0-1])$/.test(value)) {
      return {
        msg: '',
        value: value,
        isValid: true
      };
    } else {
      return {
        msg: '请按照正确的日期格式填写:xxxx/xx/xx',
        value: null,
        isValid: false
      };
    }
  },
  number: (value, columnId) => {
    const isEmpty = isAndAllowEmpty(value, columnId);
    if (isEmpty) {
      return isEmpty;
    }
    if (/^[+-]?\d+\.?\d*$/.test(value)) {
      const reg = /\B(?=(\d{3})+(?!\d))/g;
      const parts = value.replace('%', '').split('.');
      if (parts[1]) {
        parts[1] = '.' + parts[1];
      } else {
        parts[1] = '';
      }
      return {
        msg: '',
        value: `${parts[0].replace(reg, ',')}${parts[1]}`,
        isValid: true
      };
    } else {
      return {
        msg: '请按照正确的数字格式填写（可带正负号）',
        value: null,
        isValid: false
      };
    }
  },
  rounds: (value, columnId, legalRounds) => {
    const isEmpty = isAndAllowEmpty(value, columnId);
    if (isEmpty) {
      return isEmpty;
    }
    legalRounds = legalRounds.map(_ => _.name);
    if (legalRounds.includes(value)) {
      return {
        msg: '',
        value: value,
        isValid: true
      };
    } else {
      return {
        msg: '当前系统中不存在此轮次,请联系小美添加',
        value: null,
        isValid: false
      };
    }
  },
  currency: (value, columnId) => {
    const isEmpty = isAndAllowEmpty(value, columnId);
    if (isEmpty) {
      return isEmpty;
    }
    if (['USD', 'CNY'].includes(value)) {
      return {
        msg: '',
        value: value,
        isValid: true
      };
    } else {
      return {
        msg: '请填写 USD 或 CNY',
        value: null,
        isValid: false
      };
    }
  },
  // 枚举

  // 布尔值-是或否
  bool: (value, columnId) => {
    const isEmpty = isAndAllowEmpty(value, columnId);
    if (isEmpty) {
      return isEmpty;
    }
    if (['是', '否'].includes(value)) {
      return {
        msg: '',
        value: value,
        isValid: true
      };
    } else {
      return {
        msg: '请填写 是 或 否',
        value: null,
        isValid: false
      };
    }
  },

  enum: (value, columnId, valueMap) => {
    const isEmpty = isAndAllowEmpty(value, columnId);
    if (isEmpty) {
      return isEmpty;
    }
    let valueList = Object.values(valueMap);
    if (valueList.includes(value)) {
      return {
        msg: '',
        value: value,
        isValid: true
      };
    } else {
      return {
        msg:
          '该字段仅可填写' +
          valueList
            .map(e => `"${e}"`)
            .reduce((e, sum) => {
              return e + '或' + sum;
            }),
        value: null,
        isValid: false
      };
    }
  }
};
export const unrealizedValidatorMap = {
  portFolio: null,
  totalCost: 'number',
  totalFMV: 'number',
  totalMOIC: 'number',
  fullyDilutedOwnership: 'percentage',
  classOfShare: 'rounds',
  initialInvestmentDate: 'date',
  investmentCost: 'number',
  fairValue: 'number',
  cumulativeUnrealized: 'number',
  MOIC: 'number',
  fullyDilutedOwnership: 'percentage',
  valuationMethod: null,
  valuationDate: null,
  valuationMatter: null,
  projectValuation: 'number',
  shareUnitPrice: 'number',
  shareNum: 'number',
  valuationRounds: 'rounds',
  preValuation: 'number',
  postValuation: 'number',
  preShareScale: 'percentage',
  postShareScale: 'percentage',
  pricePerShare: 'number',
  originalShareUnitPrice: 'number',
  projectValuation2: null,
  bookRate: 'number',
  reportRate: 'number',
  rateUndulate: 'percentage',
  rateMatter: null,
  remark: null,

  classOfShare: 'rounds',
  latestValuationRoundsId: 'rounds',
  thisClassOfShareId: 'rounds',
  eventClassOfShareId: 'rounds',
  fullyDilutedOwnership: 'percentage',
  irr: 'percentage',
  fullyDilutedOwnership: 'percentage',
  preShareScale: 'percentage',
  eventSharePer: 'percentage',
  rateUndulate: 'percentage',
  initialInvestmentDate: 'date',
  latestValuationDate: 'date',
  deliveryDate: 'date',
  buybackDeadline: 'date',
  eventHappenDate: 'date',
  eventEffectDate: 'date',
  totalCost: 'number',
  totalFMV: 'number',
  totalIncome: 'number',
  totalMOIC: 'number',
  investmentCost: 'number',
  fairValue: 'number',
  cumulativeUnrealized: 'number',
  MOIC: 'number',
  latestBookRate: 'number',
  latestPreValuation: 'number',
  latestPostValuation: 'number',
  latestTotalShareNum: 'number',
  latestValuationPerShare: 'number',
  amount: 'number',
  shareNum: 'number',
  shareUnitPrice: 'number',
  financingAllAmount: 'number',
  originalBookRate: 'number',
  originalPreValuation: 'number',
  originalPostValuation: 'number',
  originalTotalShareNum: 'number',
  thisShareUnitPrice: 'number',
  adjust: 'number',
  eventAmount: 'number',
  eventShareNum: 'number',
  eventTotalShareNum: 'number',
  eventAmountUnitShare: 'number',
  reportRate: 'number',
  exchangeRate: 'number',

  latestValuationCurrency: 'currency',
  currency: 'currency',
  originalValuationCurrency: 'currency',
  eventCurrency: 'currency',

  isFivett: 'bool',
  isSmes: 'bool',
  latestFocusOnValuationCompany: 'bool',
  isFinancialAdjustment: 'bool',

  companyStatus: 'enum',
  nodeType: 'enum',
  nodeTypeRound: 'enum',
  dealType: 'enum',
  eventType: 'enum',

  latestRoundFinancingRoundId: 'rounds',
  latestRoundValuationCurrency: 'currency',
  latestRoundFinancialDeliveryDate: 'date',
  latestRoundPreValuation: 'number',
  latestRoundPostValuation: 'number',
  latestRoundPreShareRatio: 'percentage',
  latestRoundPostShareRatio: 'percentage',
  latestRoundPostTotalShareNum: 'number',
  latestRoundPostShareUnitPrice: 'number',
  latestRoundCurrentTotalShareNum: 'number',

  financialAdjustmentDate: 'date',
  financialAdjustmentCurrency: 'currency',
  financialAdjustmentShareUnitPrice: 'number',
  financialAdjustmentPostValuation: 'number',
  reportRate: 'number'
};
export const realizedValidatorMap = {
  portFolio: null,
  totalCost: 'number',
  totalProceeds: 'number',
  totalMOIC: 'number',
  fullyDilutedOwnership: null,
  classOfShare: 'rounds',
  initialInvestmentDate: 'date',
  investmentCost: 'number',
  proceeds: 'number',
  cumulativeUnrealized: 'number',
  MOIC: 'number',
  fullyDilutedOwnership: '',

  totalFullyDilutedOwnership: 'percentage',
  irr: 'percentage',
  fullyDilutedOwnership: 'percentage',
  investPreShareScale: 'percentage',
  classOfShare: 'rounds',
  investClassOfShareId: 'rounds',
  investThisClassOfShareId: 'rounds',
  proceedDate: 'date',
  initialInvestmentDate: 'date',
  investDeliveryDate: 'date',
  investBuybackDeadline: 'date',

  totalCost: 'number',
  totalProceeds: 'number',
  totalIncome: 'number',
  exitMOIC: 'number',
  investmentCost: 'number',
  proceeds: 'number',
  allocatedAmount: 'number',
  cumulativeUnrealized: 'number',
  MOIC: 'number',
  shareNum: 'number',
  amountPerShareNum: 'number',
  investAmount: 'number',
  investShareNum: 'number',
  investShareUnitPrice: 'number',
  investFinancingAllAmount: 'number',
  investOriginalBookRate: 'number',
  investOriginalPreValuation: 'number',
  investOriginalPostValuation: 'number',
  investOriginalTotalShareNum: 'number',
  investPricePerShare: 'number',
  investOriginalShareUnitPrice: 'number',
  investThisShareUnitPrice: 'number',
  investAdjust: 'number',

  investCurrency: 'currency',
  investOriginalValuationCurrency: 'currency',

  isFivett: 'bool',
  isSmes: 'bool',

  companyStatus: 'enum',
  nodeType: 'enum',
  nodeTypeRound: 'enum',
  exitType: 'enum',
  investDealType: 'enum'
};

export const requiredMap = [
  'portfolio',
  'companyStatus',
  'businessName',
  'projectPeopleName',
  'classOfShare',
  'initialInvestmentDate',
  'investmentCost',
  'latestValuationDate',
  'latestFocusOnValuationCompany',
  'latestValuationMethod',
  'latestValuationMatter',
  'latestValuationRoundsId',
  'latestValuationCurrency',
  'latestBookRate',
  'latestPreValuation',
  'latestPostValuation',
  'latestTotalShareNum',
  'latestValuationPerShare',
  'dealType',
  'thisClassOfShareId',
  'fundName',
  'currency',
  'deliveryDate',
  'amount',
  'bu',
  'originalValuationCurrency',
  'classOfShare',
  'proceedDate',
  'investmentCost',
  'proceeds',
  'initialInvestmentDate',
  'exitType',
  'investDealType',
  'investClassOfShareId',
  'investThisClassOfShareId',
  'investFundName',
  'investCurrency',
  'investDeliveryDate',
  'investAmount',
  'investBu',
  'investOriginalValuationCurrency'
];

function isAndAllowEmpty(value, columnId) {
  if (value === '' || value === null || value === undefined) {
    if (requiredMap.includes(columnId)) {
      return {
        msg: '该字段不可为空',
        value: null,
        isValid: false
      };
    } else {
      return {
        msg: '',
        value: '',
        isValid: true
      };
    }
  } else {
    return false;
  }
}
